import React from 'react';
import { Spinner } from 'reactstrap';


export const LoaderSpin = (props) => ( 
  <div className={"d-flex align-items-center justify-content-center " + props.className} style={{height: props.height ? props.height : "100vh"}}>
    <Spinner color={props.color ? props.color : "primary"} />
  </div>
)